import {useIsFeatureActive} from '@aboutyou/feature-flags';
import {useHistory, useIsLaunchTeaserPage} from '@aboutyou/router';
import {useRef} from 'react';

export const HIDE_HEADER_QUERY_PARAM = 'hideheader';
export const HIDE_FOOTER_QUERY_PARAM = 'hidefooter';

export const useFullScreenView = () => {
  const queryParams = new URLSearchParams(useHistory().location.search);
  const isOnLaunchTeaserPage = useIsLaunchTeaserPage();
  const {isActive} = useIsFeatureActive('enable_country_exit');
  const {isActive: isActiveV2} = useIsFeatureActive('enable_country_exit_v2');
  const hideHeaderByQueryParam = useRef(
    queryParams.get(HIDE_HEADER_QUERY_PARAM) === '1',
  ).current;
  const hideFooterByQueryParam = useRef(
    queryParams.get(HIDE_FOOTER_QUERY_PARAM) === '1',
  ).current;
  const isCountryExitActive = isActive && !isActiveV2;

  const isHeaderDisabled =
    hideHeaderByQueryParam || isOnLaunchTeaserPage || isCountryExitActive;
  const isFooterDisabled =
    hideFooterByQueryParam || isOnLaunchTeaserPage || isCountryExitActive;

  return {
    isHeaderDisabled,
    isFooterDisabled,
  };
};
